<script>
import ForkissIcon from './forkiss-icon';

export default {
    components: {
        ForkissIcon
    },
    props: {
        activeId: {
            type: String,
            default: 'home'
        }
    },
    methods: {
        goto(name) {
            if (name === 'pregnancy') {
                this.$router.push({
                    name: +window.userInfo.category === 2 ? 'postpartum' : 'pregnancy'
                });
            }
            else {
                this.$router.push({name});
            }
        }
    }
}
</script>

<template lang="pug">
.forkiss-footer-container
    .forkiss-footer-wrapper
        .forkiss-footer-box(:class="{active: activeId === 'home'}",
            @click="goto('home')")
            ForkissIcon.forkiss-footer-img(:showLabel="false",
                :icon="activeId === 'home' ? 'forkiss-icon-home active' : 'forkiss-icon-home'")
            .forkiss-footer-text 首页
        .forkiss-footer-box(:class="{active: activeId === 'classes'}",
            @click="goto('pregnancy')")
            ForkissIcon.forkiss-footer-img(:showLabel="false",
                :icon="activeId === 'classes' ? 'forkiss-icon-classes active' : 'forkiss-icon-classes'")
            .forkiss-footer-text 课程
        .forkiss-footer-box(:class="{active: activeId === 'my-order'}",
            @click="goto('public-order')")
            ForkissIcon.forkiss-footer-img(:showLabel="false",
                :icon="activeId === 'my-order' ? 'forkiss-icon-order active' : 'forkiss-icon-order'")
            .forkiss-footer-text 我的预约
        .forkiss-footer-box(:class="{active: activeId === 'my-center'}",
            @click="goto('my-center')")
            ForkissIcon.forkiss-footer-img(:showLabel="false",
                :icon="activeId === 'my-center' ? 'forkiss-icon-center active' : 'forkiss-icon-center'")
            .forkiss-footer-text 个人中心
</template>


<style lang="less" scoped>
.forkiss-footer-container {
    position: fixed;
    z-index: 65;
    width: 100%;
    height: 1rem;
    bottom: 0;
    background: #FFF;
    box-shadow: 0 -.03px .12rem 0 rgba(0, 0, 0, .07);

    .forkiss-footer-wrapper {
        display: flex;
    }

    .forkiss-footer-box {
        flex: 1;
        text-align: center;

        &.active {


            .forkiss-footer-text {
                color: #c0a783;
            }
        }
    }

    .forkiss-footer-img {
        margin: .12rem auto 0;
    }

    .forkiss-footer-text {
        margin-top: .1rem;
        font-size: .2rem;
        color: #828d93;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue